/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */
import * as References from './AiAgentInstancesChirpServiceV2';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstance
 */
export const GET_AGENT_INSTANCE_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstance';
export const GET_AGENT_INSTANCE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_INSTANCE_QUERY_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesByIDs
 */
export const GET_AGENT_INSTANCES_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesByIDs';
export const GET_AGENT_INSTANCES_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_INSTANCES_BY_IDS_QUERY_FIELD_NAME,
  args: ['ids'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getAgentInstancesByIDsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesMetadataByIDs
 */
export const GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesMetadataByIDs';
export const GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY_FIELD_NAME,
  args: ['ids'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getAgentInstancesMetadataByIDsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesWithSnapshots
 */
export const GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesWithSnapshots';
export const GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY_FIELD_NAME,
  args: ['items'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getAgentInstancesWithSnapshotsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesByWorkflowId
 */
export const GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesByWorkflowId';
export const GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY_FIELD_NAME,
  args: ['workflowId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getAgentInstancesByWorkflowIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getActiveAgentInstances
 */
export const GET_ACTIVE_AGENT_INSTANCES_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getActiveAgentInstances';
export const GET_ACTIVE_AGENT_INSTANCES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACTIVE_AGENT_INSTANCES_QUERY_FIELD_NAME,
  args: ['visibility', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getActiveAgentInstancesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#listAgentInstances
 */
export const LIST_AGENT_INSTANCES_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_listAgentInstances';
export const LIST_AGENT_INSTANCES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_AGENT_INSTANCES_QUERY_FIELD_NAME,
  args: ['authorName', 'updatedBy', 'searchTerm', 'runLimitStatusFilter', 'pageLength', 'createdBy', 'visibilities', 'visibility', 'requiredAccessType', 'sortField', 'sortDirection', 'statuses', 'permissionTypeFilters', 'agentScopeFilter', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.listAgentInstancesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#searchAgentInstances
 */
export const SEARCH_AGENT_INSTANCES_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_searchAgentInstances';
export const SEARCH_AGENT_INSTANCES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_AGENT_INSTANCES_QUERY_FIELD_NAME,
  args: ['searchTerms', 'pageLength', 'createdBy', 'visibilities', 'visibility', 'requiredAccessType', 'sortField', 'sortDirection', 'statuses', 'permissionTypeFilters', 'agentScopeFilter', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.searchAgentInstancesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createAgentInstance
 */
export const CREATE_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createAgentInstance';
export const CREATE_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['instance', 'triggerFlowIds', 'permissions', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.createAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceV2
 */
export const UPDATE_AGENT_INSTANCE_V2_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceV2';
export const UPDATE_AGENT_INSTANCE_V2_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_V2_MUTATION_FIELD_NAME,
  args: ['id', 'instance', 'triggerFlowIds', 'permissions', 'feedbackCorrelationId', 'recommendationMetadata'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.updateAgentInstanceV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceV3
 */
export const UPDATE_AGENT_INSTANCE_V3_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceV3';
export const UPDATE_AGENT_INSTANCE_V3_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_V3_MUTATION_FIELD_NAME,
  args: ['id', 'instance', 'triggerFlowIds', 'permissions', 'feedbackCorrelationId', 'recommendationMetadata', 'clientHeadSnapshotId', 'forceCreate'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.updateAgentInstanceV3Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#patchAgentInstance
 */
export const PATCH_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_patchAgentInstance';
export const PATCH_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PATCH_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['id', 'instance'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.patchAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentMetadata
 */
export const UPDATE_AGENT_METADATA_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentMetadata';
export const UPDATE_AGENT_METADATA_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_METADATA_MUTATION_FIELD_NAME,
  args: ['id', 'name', 'description', 'icon'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.updateAgentMetadataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentAvailability
 */
export const UPDATE_AGENT_AVAILABILITY_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentAvailability';
export const UPDATE_AGENT_AVAILABILITY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_AVAILABILITY_MUTATION_FIELD_NAME,
  args: ['id', 'isBreezeEnabled'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.updateAgentAvailabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#unpublishAgentInstance
 */
export const UNPUBLISH_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_unpublishAgentInstance';
export const UNPUBLISH_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNPUBLISH_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.unpublishAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#resetToLatestTemplate
 */
export const RESET_TO_LATEST_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_resetToLatestTemplate';
export const RESET_TO_LATEST_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: RESET_TO_LATEST_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['instanceId'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.resetToLatestTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#softDeleteAgentInstance
 */
export const SOFT_DELETE_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_softDeleteAgentInstance';
export const SOFT_DELETE_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SOFT_DELETE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.softDeleteAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#softDeleteAgentInstanceV2
 */
export const SOFT_DELETE_AGENT_INSTANCE_V2_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_softDeleteAgentInstanceV2';
export const SOFT_DELETE_AGENT_INSTANCE_V2_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SOFT_DELETE_AGENT_INSTANCE_V2_MUTATION_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.softDeleteAgentInstanceV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createInstanceFromTemplate
 */
export const CREATE_INSTANCE_FROM_TEMPLATE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createInstanceFromTemplate';
export const CREATE_INSTANCE_FROM_TEMPLATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_INSTANCE_FROM_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateId', 'objective', 'components', 'builtInTools', 'detach'],
  fetcher(request, ctx) {
    var _ctx$customClient19;
    return ((_ctx$customClient19 = ctx.customClient) !== null && _ctx$customClient19 !== void 0 ? _ctx$customClient19 : chirpClient).call(References.createInstanceFromTemplateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createInstanceFromTemplateByGlobalId
 */
export const CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createInstanceFromTemplateByGlobalId';
export const CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION_FIELD_NAME,
  args: ['globalId', 'globalIdString', 'objective', 'components', 'builtInTools', 'desiredStatus', 'detach'],
  fetcher(request, ctx) {
    var _ctx$customClient20;
    return ((_ctx$customClient20 = ctx.customClient) !== null && _ctx$customClient20 !== void 0 ? _ctx$customClient20 : chirpClient).call(References.createInstanceFromTemplateByGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#cloneAgentInstance
 */
export const CLONE_AGENT_INSTANCE_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_cloneAgentInstance';
export const CLONE_AGENT_INSTANCE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLONE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['instanceId', 'cloneName', 'cloneStatus', 'detach'],
  fetcher(request, ctx) {
    var _ctx$customClient21;
    return ((_ctx$customClient21 = ctx.customClient) !== null && _ctx$customClient21 !== void 0 ? _ctx$customClient21 : chirpClient).call(References.cloneAgentInstanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#cloneAgentsForFlow
 */
export const CLONE_AGENTS_FOR_FLOW_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_cloneAgentsForFlow';
export const CLONE_AGENTS_FOR_FLOW_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLONE_AGENTS_FOR_FLOW_MUTATION_FIELD_NAME,
  args: ['instanceIds', 'newWorkflowId'],
  fetcher(request, ctx) {
    var _ctx$customClient22;
    return ((_ctx$customClient22 = ctx.customClient) !== null && _ctx$customClient22 !== void 0 ? _ctx$customClient22 : chirpClient).call(References.cloneAgentsForFlowRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getInstancesByTemplateIds
 */
export const GET_INSTANCES_BY_TEMPLATE_IDS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getInstancesByTemplateIds';
export const GET_INSTANCES_BY_TEMPLATE_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTANCES_BY_TEMPLATE_IDS_QUERY_FIELD_NAME,
  args: ['templateIds'],
  fetcher(request, ctx) {
    var _ctx$customClient23;
    return ((_ctx$customClient23 = ctx.customClient) !== null && _ctx$customClient23 !== void 0 ? _ctx$customClient23 : chirpClient).call(References.getInstancesByTemplateIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getInstancesByGlobalId
 */
export const GET_INSTANCES_BY_GLOBAL_ID_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getInstancesByGlobalId';
export const GET_INSTANCES_BY_GLOBAL_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INSTANCES_BY_GLOBAL_ID_QUERY_FIELD_NAME,
  args: ['globalId', 'globalIdString'],
  fetcher(request, ctx) {
    var _ctx$customClient24;
    return ((_ctx$customClient24 = ctx.customClient) !== null && _ctx$customClient24 !== void 0 ? _ctx$customClient24 : chirpClient).call(References.getInstancesByGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceOwner
 */
export const UPDATE_AGENT_INSTANCE_OWNER_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceOwner';
export const UPDATE_AGENT_INSTANCE_OWNER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_OWNER_MUTATION_FIELD_NAME,
  args: ['agentInstanceId', 'newOwnerId'],
  fetcher(request, ctx) {
    var _ctx$customClient25;
    return ((_ctx$customClient25 = ctx.customClient) !== null && _ctx$customClient25 !== void 0 ? _ctx$customClient25 : chirpClient).call(References.updateAgentInstanceOwnerRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceFromSnapshot
 */
export const UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceFromSnapshot';
export const UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME,
  args: ['instanceId', 'snapshotId', 'additionalSetupInputs', 'authorName', 'triggerFlowIds', 'permissions'],
  fetcher(request, ctx) {
    var _ctx$customClient26;
    return ((_ctx$customClient26 = ctx.customClient) !== null && _ctx$customClient26 !== void 0 ? _ctx$customClient26 : chirpClient).call(References.updateAgentInstanceFromSnapshotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#cloneInstanceFromSnapshot
 */
export const CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_cloneInstanceFromSnapshot';
export const CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME,
  args: ['instanceId', 'snapshotId', 'cloneName', 'cloneStatus', 'detach'],
  fetcher(request, ctx) {
    var _ctx$customClient27;
    return ((_ctx$customClient27 = ctx.customClient) !== null && _ctx$customClient27 !== void 0 ? _ctx$customClient27 : chirpClient).call(References.cloneInstanceFromSnapshotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#validateAgentInstanceReadiness
 */
export const VALIDATE_AGENT_INSTANCE_READINESS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_validateAgentInstanceReadiness';
export const VALIDATE_AGENT_INSTANCE_READINESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: VALIDATE_AGENT_INSTANCE_READINESS_QUERY_FIELD_NAME,
  args: ['instanceId', 'instancePayload', 'runtimeInputs'],
  fetcher(request, ctx) {
    var _ctx$customClient28;
    return ((_ctx$customClient28 = ctx.customClient) !== null && _ctx$customClient28 !== void 0 ? _ctx$customClient28 : chirpClient).call(References.validateAgentInstanceReadinessRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#validateAgentInstanceReadinessV2
 */
export const VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_validateAgentInstanceReadinessV2';
export const VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY_FIELD_NAME,
  args: ['agentInstanceId'],
  fetcher(request, ctx) {
    var _ctx$customClient29;
    return ((_ctx$customClient29 = ctx.customClient) !== null && _ctx$customClient29 !== void 0 ? _ctx$customClient29 : chirpClient).call(References.validateAgentInstanceReadinessV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#bulkValidateAgentInstancesReadiness
 */
export const BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_bulkValidateAgentInstancesReadiness';
export const BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY_FIELD_NAME,
  args: ['instanceIds'],
  fetcher(request, ctx) {
    var _ctx$customClient30;
    return ((_ctx$customClient30 = ctx.customClient) !== null && _ctx$customClient30 !== void 0 ? _ctx$customClient30 : chirpClient).call(References.bulkValidateAgentInstancesReadinessRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#bulkCreateAgentInstances
 */
export const BULK_CREATE_AGENT_INSTANCES_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_bulkCreateAgentInstances';
export const BULK_CREATE_AGENT_INSTANCES_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: BULK_CREATE_AGENT_INSTANCES_MUTATION_FIELD_NAME,
  args: ['instances'],
  fetcher(request, ctx) {
    var _ctx$customClient31;
    return ((_ctx$customClient31 = ctx.customClient) !== null && _ctx$customClient31 !== void 0 ? _ctx$customClient31 : chirpClient).call(References.bulkCreateAgentInstancesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#bulkCreateAgentInstancesByKey
 */
export const BULK_CREATE_AGENT_INSTANCES_BY_KEY_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_bulkCreateAgentInstancesByKey';
export const BULK_CREATE_AGENT_INSTANCES_BY_KEY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: BULK_CREATE_AGENT_INSTANCES_BY_KEY_MUTATION_FIELD_NAME,
  args: ['instances'],
  fetcher(request, ctx) {
    var _ctx$customClient32;
    return ((_ctx$customClient32 = ctx.customClient) !== null && _ctx$customClient32 !== void 0 ? _ctx$customClient32 : chirpClient).call(References.bulkCreateAgentInstancesByKeyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#bulkSoftDeleteAgentInstances
 */
export const BULK_SOFT_DELETE_AGENT_INSTANCES_MUTATION_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_bulkSoftDeleteAgentInstances';
export const BULK_SOFT_DELETE_AGENT_INSTANCES_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: BULK_SOFT_DELETE_AGENT_INSTANCES_MUTATION_FIELD_NAME,
  args: ['instanceIds'],
  fetcher(request, ctx) {
    var _ctx$customClient33;
    return ((_ctx$customClient33 = ctx.customClient) !== null && _ctx$customClient33 !== void 0 ? _ctx$customClient33 : chirpClient).call(References.bulkSoftDeleteAgentInstancesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentConnections
 */
export const GET_AGENT_CONNECTIONS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentConnections';
export const GET_AGENT_CONNECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AGENT_CONNECTIONS_QUERY_FIELD_NAME,
  args: ['agentInstanceId'],
  fetcher(request, ctx) {
    var _ctx$customClient34;
    return ((_ctx$customClient34 = ctx.customClient) !== null && _ctx$customClient34 !== void 0 ? _ctx$customClient34 : chirpClient).call(References.getAgentConnectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getGlobalAgentConnections
 */
export const GET_GLOBAL_AGENT_CONNECTIONS_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getGlobalAgentConnections';
export const GET_GLOBAL_AGENT_CONNECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_GLOBAL_AGENT_CONNECTIONS_QUERY_FIELD_NAME,
  args: ['agentInstanceId', 'filterByConnectionTypes', 'evaluateBreakingChanges'],
  fetcher(request, ctx) {
    var _ctx$customClient35;
    return ((_ctx$customClient35 = ctx.customClient) !== null && _ctx$customClient35 !== void 0 ? _ctx$customClient35 : chirpClient).call(References.getGlobalAgentConnectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#listAgentInstancesWithInvocability
 */
export const LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY_FIELD_NAME = 'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_listAgentInstancesWithInvocability';
export const LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY_FIELD_NAME,
  args: ['pageLength', 'sortField', 'sortDirection', 'filterToBreezeEnabledOnly', 'searchTerm', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient36;
    return ((_ctx$customClient36 = ctx.customClient) !== null && _ctx$customClient36 !== void 0 ? _ctx$customClient36 : chirpClient).call(References.listAgentInstancesWithInvocabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});